const e = {
  xxl: {
    fontSize: "32px",
    lineHeight: 1.25,
    letterSpacing: 0
  },
  xl: {
    fontSize: "2xl",
    lineHeight: 1.25,
    letterSpacing: 0
  },
  lg: {
    fontSize: "lg",
    lineHeight: "16px",
    letterSpacing: 0
  },
  md: {
    fontSize: "md",
    lineHeight: "14px",
    letterSpacing: "0"
  },
  sm: {
    fontSize: "sm",
    lineHeight: "12px",
    letterSpacing: "0"
  },
  xs: {
    fontSize: "2xs",
    lineHeight: "10px",
    letterSpacing: "0"
  }
};
export {
  e as textStyles
};
//# sourceMappingURL=textStyles.es.js.map
